import styles from "./styles/rate-convert-modal-content.module.scss";
import CheckBox from "@/components/common/checkbox";
import StyledMultilineInput from "@/components/common/styled-multiline-input";
import Image from "next/image";
import emailIcon from "@/assets/icons/email.svg";
import React, { useState } from "react";
import { useCurrentUser } from "@/hooks/use-current-user";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { showFeedbackSentNotification } from "@/utils/notification-helper";

interface RateConvertModalContentProps {
  ratePresets: string[];
  type: "like" | "dislike";
  convertId: string;
}

const RateConvertModalContent = ({
  ratePresets,
  type,
  convertId,
}: RateConvertModalContentProps) => {
  const user = useCurrentUser();
  const [selectedRates, setSelectedRates] = useState<string[]>([]);
  const [otherRate, setOtherRate] = useState<string>("");
  const isButtonActive = selectedRates.length > 0 || otherRate.length > 0;
  const { hideModal } = useGlobalModalContext();
  const toggleRate = (text: string) => {
    setSelectedRates((prev) =>
      prev.includes(text)
        ? prev.filter((item) => item !== text)
        : [...prev, text],
    );
  };

  const handleSend = async () => {
    hideModal();
    showFeedbackSentNotification();
    await fetch("/api/convert/feedback", {
      method: "POST",
      body: JSON.stringify({
        convertId: convertId,
        feedback: selectedRates.join(", "),
        feedbackText: otherRate,
        email: user?.email,
        type: type,
      }),
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Why did this sound good?</div>
      <div className={styles.rates_wrapper}>
        {ratePresets.map((preset) => (
          <div
            key={preset}
            className={styles.rate_item}
            onClick={() => toggleRate(preset)}
          >
            <CheckBox
              isChecked={selectedRates.includes(preset)}
              onChange={() => {}}
            />
            {preset}
          </div>
        ))}
      </div>
      <div className={styles.input_wrapper}>
        <div className={styles.input_title}>Leave feedback (optional)</div>
        <StyledMultilineInput
          overriddenClass={styles.message}
          placeholder="Leave feedback here"
          maxlength={400}
          value={otherRate}
          onChange={(e) => setOtherRate(e.target.value)}
          isValid={true}
        />
      </div>
      <button
        className={styles.send_button}
        disabled={!isButtonActive}
        onClick={handleSend}
      >
        <Image src={emailIcon} alt={"email"} />
        Send
      </button>
    </div>
  );
};

export default RateConvertModalContent;
